import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from 'components/new_ui/Table';

import getPaymentMethodLink from 'components/Common/Billing/utils/getPaymentMethodLink';
import { useContext } from 'components/Managers/Billing/Context';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';
import ChooseEditPaymentMethodMode from './ChooseEditPaymentMethodMode';
import columns from './columns';
import ButtonW9Form from './ButtonW9Form';
import Form from './Form';

export default function List({ paymentMethods }) {
  const { actions, dispatch } = useContext();

  const [show, setShow] = useState(false);
  const [paymentMethodForEdit, setPaymentMethodForEdit] = useState(null);
  const [editRow, setEditRow] = useState(null);

  const onSetPaymentMethod = (rowId) => {
    getPaymentMethodLink({
      paymentInformationId: rowId,
    }).then((res) => {
      document.location.href = res.link;
    });
  };

  const onDeletePaymentMethod = (rowId) => {
    confirmAlert({
      title: 'Confirm Removal',
      text: `Are you sure you want to remove this payment method? This action cannot be undone. 
      Future payments will require a new method.`,
      confirmButtonText: 'Delete',
    }, () => {
      actions.deleteLinkedPaymentMethod(dispatch, rowId, (errors) => {
        Alert({
          title: 'Action Required',
          text: errors.map((item) => item.title).join('.'),
        });
      });
    });
  };

  return (
    <section className="pt-2">
      <div className="d-flex justify-content-end">
        <ButtonW9Form />
      </div>
      <Table
        columns={columns(setEditRow, setShow)}
        data={paymentMethods}
        selectableRows={false}
      />
      {editRow !== null && show
      && (
      <ChooseEditPaymentMethodMode
        show
        onHide={() => setShow(false)}
        onEditInformation={() => setPaymentMethodForEdit(editRow)}
        onPaymentMethod={() => onSetPaymentMethod(editRow.id)}
        onDeletePaymentMethod={() => onDeletePaymentMethod(editRow.id)}
        isPossibleDeletePaymentMethod={editRow.attributes.payment_method_status !== ''}
      />
      )}
      {paymentMethodForEdit !== null && (
      <Form
        show
        onHide={() => setPaymentMethodForEdit(null)}
        initValue={paymentMethodForEdit}
      />
      )}
    </section>
  );
}

List.propTypes = {
  paymentMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
};
